export const slogans = [
  'Production Enhancement and Well Safety systems engineered to increase runtime and production',
  'Specialized Oil Tools; Premium Artificial Lift Solutions Designed to <span>LIFT</span>',
  'Enhancing Well Safety, Production, & Reliability',
]
